import { Link } from "react-router-dom";
import SubscribeForm from "@/components/feature/SubscribeForm";
import { categories, navLinks, siteInfo } from "@/mocks/site";

const resourceLinks = [
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-eye-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-sm">
              {siteInfo.description}
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="px-3 py-1 rounded-full text-xs bg-secondary-800 text-secondary-100">
                仅分析公开信息
              </span>
              <span className="px-3 py-1 rounded-full text-xs bg-secondary-800 text-secondary-100">
                不做隐私曝光
              </span>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/cases" className="hover:text-accent-300 transition-colors cursor-pointer">
                调查档案
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/cases?category=${encodeURIComponent(item.name)}`}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/about" className="hover:text-accent-300 transition-colors cursor-pointer">
                关于本站
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {navLinks.slice(1).map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <SubscribeForm />
            <div className="mt-6 space-y-2 text-sm text-background-200">
              <p className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-300" aria-hidden="true"></i>
                <span>
                  联系邮箱：
                  <a
                    href={`mailto:${siteInfo.email}`}
                    className="hover:text-background-50 transition-colors"
                  >
                    {siteInfo.email}
                  </a>
                </span>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-lightbulb-line mt-0.5 text-accent-300" aria-hidden="true"></i>
                <span>
                  线索投递：
                  <a
                    href={`mailto:${siteInfo.tipEmail}`}
                    className="hover:text-background-50 transition-colors"
                  >
                    {siteInfo.tipEmail}
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-300 leading-relaxed max-w-2xl">
            本站内容基于公开报道、平台通报与公开文书整理，仅用于公共议题讨论与风险提示，不构成法律意见。所涉个案均存在差异，请勿据此对任何具体个人作出判断。
          </p>
          <ul className="flex flex-wrap items-center gap-4">
            {resourceLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-xs text-background-300 hover:text-background-50 whitespace-nowrap transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <p className="mt-4 text-xs text-background-400">
          © 2026 {siteInfo.name} 编辑部 · 转载请注明来源并保留原文链接
        </p>
      </div>
    </footer>
  );
}